<template>
  <v-row :class="$vuetify.breakpoint.mdAndUp?'mb-4':'mb-10'" :justify="$vuetify.breakpoint.smAndDown?'center':'start'">
    <v-col
      cols="12"
      sm="6"
      md="4"
      lg="3"
      v-for="item in items"
      :key="item.id"
      class="mb-5"
    >
      <event-card :event="item" @openDialogToDeleteEvent="openDialogToDeleteEvent" @openDialogToDuplicateEvent="openDuplicateActionDialog"></event-card>
    </v-col>
    <!-- INICIO Dialog para confirmar la eliminación de un evento -->
    <v-dialog v-model="deleteEventDialog" width="600">
      <v-card>
        <v-card-text>
          <v-row justify="center">
            <v-col cols="10" md="7" class="mt-8 d-flex justify-center">
              <v-img class="" src="@/assets/images/weChamber/logo-WC-main-nav-drawer.svg" max-width="220" height="auto" contain></v-img>
            </v-col>
          </v-row>
          <v-row>
          <v-col cols="12" class="mt-2">
            <p class="text-center font-weight-bold headline mb-0">
              Eliminar evento
            </p>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <p class="title text-center mb-0">¿Está seguro que quiere eliminar el evento seleccionado?</p>
            <p class="title text-center">Los datos del evento no podrán ser recuperados.</p>
          </v-col>
        </v-row>
        <v-row
          class="d-flex pb-2 mt-5"
          :class="
            $vuetify.breakpoint.smAndUp ? 'justify-end' : 'justify-center'
          "
        >
          <v-btn class="font-weight-bold black--text mx-2" color="grey lighten-3" rounded elevation="0" @click="deleteEventDialog = false">
            Cancelar
          </v-btn>
          <v-btn class="font-weight-bold black--text mx-2" color="accent" rounded elevation="0" @click="$_deleteEvent()">
            Aceptar
          </v-btn>
        </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- FIN Dialog para confirmar la eliminación de un evento -->
    <PersonalizedDialog
      hideName
      :dialog="!!eventToDuplicate"
      :disableContinueButton="!checkDuplicateConditions"
      @save="$_duplicateEvent()"
      @discard="resetValues()"
    >
      <template v-slot:alertContent>
      <div class="d-flex flex-column">
        <span v-if="!!eventToDuplicate" class="title mb-4">
          Estás seguro de duplicar el evento <b>{{ eventToDuplicate.name }}</b>? <br>
        </span>
        <p style="font-size: 12pt">
          Se duplicará las configuraciones bases del evento y del micrositio. Los accesos y cupones no serán duplicados.
        </p>
        <v-checkbox
          v-model="checkDuplicateConditions"
          label="Acepto que al clonar el evento, solo se copiarán los elementos básicos y que los accesos y cupones no serán clonados."
        />
      </div>
      </template>
    </PersonalizedDialog>

  </v-row>
</template>

<script>
import eventCard from "./EventCard";
import PersonalizedDialog from "../../shared/PersonalizedDialog.vue";
import { mapMutations, mapActions } from "vuex";

export default {
  components: {
    eventCard,
    PersonalizedDialog
  },
  props: {
    items: { type: Array, required: true },
  },
  data() {
    return {
      eventSelectedId: null,
      deleteEventDialog: false,
      eventToDuplicate: null,
      checkDuplicateConditions: false
    }
  },
  methods: {
    ...mapActions("event", ["deleteEvent", "duplicateEvent"]),
    ...mapMutations("notification", ["show"]),
    ...mapMutations("loader", ["loading", "loaded"]),
    ...mapActions("user", ["getIndicators"]),
    async $_deleteEvent() {
      this.loading();
      let response = await this.deleteEvent(this.eventSelectedId);
      this.show({
        text: response.message,
        color: response.status?"primary":"error"
      });
      this.deleteEventDialog = false;
      await this.getIndicators();
      this.$emit('fetchEventsAfterDelete');
      this.loaded();
    },
    async $_duplicateEvent() {
      this.loading();
      try {
        let response = await this.duplicateEvent(this.eventToDuplicate._id);

        if (!response.status) {
          throw new Error("Error al duplicar este evento")
        }

        this.$router.push(`/mi-evento/micrositio/${response.data.event}`);

      } catch (error) {
        this.show({
          text: error.message,
          color:"error"
        });
      } finally {
        this.resetValues();
        this.loaded()
      }
    },
    openDialogToDeleteEvent(eventSelectedId) {
      this.eventSelectedId = eventSelectedId;
      this.deleteEventDialog = true;
      //this.eventSelectedId = eventSelectedId;
    },
    openDuplicateActionDialog(eventData) {
      this.eventToDuplicate = eventData
    },
    resetValues() {
      this.eventToDuplicate = null;
      this.checkDuplicateConditions = false;
    }
  }
}
</script>